// src/pages/Education/helpers.js
// Мелкие презентационные утилиты журнала ДДО. Без побочных эффектов.

// Подпись значения справочника на языке интерфейса (meta.dictionaries[group]).
export function dictLabel(meta, group, value, lang) {
  const list = (meta && meta.dictionaries && meta.dictionaries[group]) || [];
  const item = list.find((o) => o.v === value);
  return item ? item[lang] || item.ru || value : value;
}

// Наименование/адрес записи на языке интерфейса; при отсутствии KK — откат на RU (ТЗ п.7).
export const nameOf = (row, lang) => (lang === 'ru' ? row.name : row.nameKz || row.name);
export const addrOf = (row, lang) => (lang === 'ru' ? row.addr : row.addrKz || row.addr);

// Число с разделителем разрядов; null/undefined → null (в UI отрисуется «—»), 0 остаётся 0.
export function formatNum(n) {
  return n == null ? null : Number(n).toLocaleString('ru-RU');
}

// Короткая подпись «городская/сельская» под названием населённого пункта.
export function localityKindLabel(locType, lang) {
  const urban = locType === 'городская местность';
  if (lang === 'ru') return urban ? 'городская' : 'сельская';
  return urban ? 'қалалық' : 'ауылдық';
}
